import mixin, { CellBelong } from './mixins'

export default {
  name: 'KDataGridHeader',
  mixins: [mixin],
  props: {},
  data() {
    return {
      cellBelong: CellBelong.HEADER,
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    this.$emit('mounted')
  },
  destroyed() {
  },
  methods: {
    handleScroll() {
      this.layout.apiHandleHeaderScroll()
    },
  },
  render() {
    const style = {}

    const css = {
      'km-data-grid__header': true,
    }

    const attrs = {}

    const events = {
      scroll: this.handleScroll,
    }

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      on: events,
      ref: 'scrollContainer',
    }

    return <div {...data}>
      <div class="km-data-grid__header--extra">
        {this.$slots.default}
      </div>
      {this.renderFixedColumns()}
      {this.renderCenterColumns()}
      {this.renderFixedColumns(true)}
    </div>
  },
}
